import React from 'react';
import { CircularProgress, styled } from '@material-ui/core';

const QuotationLoading = () => {
  return (
    <LoadingWrapper>
      <CircularProgress />
    </LoadingWrapper>
  );
};

export default QuotationLoading;

const LoadingWrapper = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: 'calc(50% - 20px)'
}));
